// @ts-nocheck
import Upload from "@store/Library/Components/Toolkit/Icons/Upload";
import { buttonGetFieldIconProps } from "@store/Themes/common/props/button";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const fileUpload: Styleguide["fileUpload"] = {
    defaultProps: {
        ...buttonGetFieldIconProps(Upload, "primary"),
    },
};

export default fileUpload;
